"use client";
import React from "react";
import VideoCard from "./Videocard";
import videos from '@/data/videos';

// The `videos` data file contains canonical site videos used by components and schema
const showcaseVideos = videos.map((v, idx) => ({
  id: String(idx + 1),
  videoId: v.id,
  title: v.title,
  thumbnailUrl: v.thumbnailUrl,
  caption: v.description || "",
}));

const ShowcaseGallery = () => {
    return (
        <section className="w-full">
            <div className=" max-w-4xl  mb-16 space-y-4">
                <h2
                    className="text-2xl sm:text-[42px] font-bold text-gray-900 mb-1"
                    style={{ fontFamily: "saans-bold" }}
                >
                    Showcase Gallery
                </h2>
                <p
                    className="text-base sm:text-[18px] text-[#000000] mb-8"
                    style={{ fontFamily: "saans-regular" }}
                >
                    Medhavi Skills University fosters an environment where students actively participate in meaningful projects that enrich their learning experience and foster personal and professional growth. These projects offer students the opportunity to delve into specialized topics or undertake hands-on projects.
                </p>
            </div>
            <div className="flex flex-wrap justify-center gap-8">
                {showcaseVideos.map((video) => (
                    < div
                        key={video.id}
                        className="w-full sm:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.3333rem)]"
                    >
                        <VideoCard {...video} />
                    </div>
                ))}
            </div>
        </section >
    );
};

export default ShowcaseGallery;
